{
  "name": "brinks-billing-reporting",
  "version": "0.0.72",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "push:build-tag": "bash ./scripts/push-build-tag.sh",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint",
    "prepare": "husky",
    "postinstall": "git submodule update --init --recursive"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "lint-staged": {
    "src/**/*.{ts,html}": [
      "eslint --fix --max-warnings=0"
    ]
  },
  "private": true,
  "packageManager": "npm@11.6.2",
  "dependencies": {
    "@angular/cdk": "^21.1.2",
    "@angular/common": "^21.0.0",
    "@angular/compiler": "^21.0.0",
    "@angular/core": "^21.0.0",
    "@angular/forms": "^21.0.0",
    "@angular/platform-browser": "^21.0.0",
    "@angular/router": "^21.0.0",
    "@floating-ui/dom": "^1.6.0",
    "color": "^5.0.3",
    "lucide-angular": "^1.0.0",
    "maplibre-gl": "^5.0.0",
    "ng-primitives": "^0.122.0",
    "remixicon": "^4.9.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^21.0.1",
    "@angular/cli": "^21.0.1",
    "@angular/compiler-cli": "^21.0.0",
    "@eslint/js": "^10.0.1",
    "angular-eslint": "21.4.0",
    "autoprefixer": "^10.4.23",
    "eslint": "^10.3.0",
    "husky": "^9.1.7",
    "lint-staged": "^17.0.4",
    "postcss": "^8.5.6",
    "tailwindcss": "^3.4.17",
    "typescript": "~5.9.2",
    "typescript-eslint": "8.59.2"
  }
}
